import styled from "styled-components";

const LoaderStyle = styled.div`
  display: flex;
  align-items: center;
  height: 10vh;
  justify-content: center;
`;

export default LoaderStyle;
